import { ProductMatrixStructure, SetupInfo } from '@store';

import {
  DiagStackGenericResponse,
  DiagStackNode,
  RemoteDiagnosticsVciAvailable,
  UseCaseTypesEnum,
} from './remote-diagnostics.model';

export namespace RemoteDiagnosticsCloudApiMockResponses {
  export const productMatrixMock: ProductMatrixStructure = {
    type: 'GetProductMatrix',
    structure: [
      {
        productFamily: 'B_00001_VVPT2',
        productNameTranslationId: 'TI_7725236',
        logicalLinkName: 'LL_0000_Main_ECU_CAN01',
        // from store
        // activatedRoute.snapshot.queryParams
        ViessmannIdentificationNumber: null,
        busType: 'CanInternal',
        translationIdLogicalLinkName: 'TI_LL_0000_Main_ECU_CAN01',
        busAddress: '1',
      },
    ],
  };

  export const useCases = {
    type: 'getAvailableUsecases',
    structure: [
      {
        unit: '',
        usecasetype: UseCaseTypesEnum.ConfigurationOverview,
        structure: [
          {
            TI_texttableentry: 'TI_General',
            interval: '0',
            texttableentry: 'General',
          },
          {
            TI_texttableentry: 'TI_Network',
            interval: '14',
            texttableentry: 'Network',
          },
          {
            TI_texttableentry: 'TI_HE_1_4',
            interval: '18',
            texttableentry: 'HE_1_4',
          },
          {
            TI_texttableentry: 'TI_DHWC_1_5',
            interval: '24',
            texttableentry: 'DHWC_1_5',
          },
        ],
      },
      {
        unit: '',
        usecasetype: UseCaseTypesEnum.DiagnosisOverview,
        structure: [
          {
            TI_texttableentry: 'TI_General',
            interval: '0',
            texttableentry: 'General',
          },
          {
            TI_texttableentry: 'TI_HE_1_4',
            interval: '18',
            texttableentry: 'HE_1_4',
          },
          {
            TI_texttableentry: 'TI_CH_2_3',
            interval: '42',
            texttableentry: 'CH_2_3',
          },
          {
            TI_texttableentry: 'TI_SC_1_1',
            interval: '52',
            texttableentry: 'SC_1_1',
          },
        ],
      },
    ],
  };

  export const diagStackNodeMock: DiagStackNode = {
    hostAndPath: 'diagstack-integration-1.viessmann-platform.io/dc-diagstack-1',
  };

  export const listMocked = {
    LL_0002_HMU_CAN01:
      'LL_0002_HMU_CAN01#ViessmannDoWS 0569bcd3-12e9-41c9-9969-d7a4b5175c05#ISO_13400_on_IEEE_802_3',
    LL_0020_HPMU_CAN01:
      'LL_0020_HPMU_CAN01#ViessmannDoWS 0569bcd3-12e9-41c9-9969-d7a4b5175c05#ISO_13400_on_IEEE_802_3',
    LL_0024_EMCU_CAN01:
      'LL_0024_EMCU_CAN01#ViessmannDoWS 0569bcd3-12e9-41c9-9969-d7a4b5175c05#ISO_13400_on_IEEE_802_3',
    LL_0016_VCU_CAN01:
      'LL_0016_VCU_CAN01#ViessmannDoWS 0569bcd3-12e9-41c9-9969-d7a4b5175c05#ISO_13400_on_IEEE_802_3',
  };

  export const availableMock: RemoteDiagnosticsVciAvailable[] = [
    {
      name: 'VirtualVCI 1',
      resources: [
        'SIM_ISO_14229_3_on_ISO_15765_2',
        'SIM_KWP2000LP_on_KLINE',
        'SIM_KWP2000_on_CAN',
        'SIM_KWP2000_on_KLINE',
        'SIM_OBD_on_CAN',
        'SIM_RAWCAN',
        'SIM_SAE_J1939_73_on_SAE_J1939_21',
        'SIM_TP16_on_CAN',
        'SIM_TP20_on_CAN',
        'SIM_UDS_on_CAN',
        'SIM_UDS_on_DoIP',
      ],
      vciType: 'Simulation',
      vendorName: 'KPIT Technologies GmbH',
      description: "VendorName='KPIT Technologies GmbH' MVCIFriendlyName='Javascript'",
      hardwareName: 'Javascript',
      hardwareSerialNumber: '0',
      hardwareVersion: '0.0.0',
      firmwareName: 'NO FIRMWARE',
      firmwareVersion: '0.0.0',
    },
    {
      name: 'VirtualDoWS-a7855437-a4a1-407d-8332-1b8a016262d6',
      resources: ['DOIP_MONITOR', 'ISO_13400_on_IEEE_802_3'],
      vciType: 'DOIP',
      vendorName: 'KPIT Technologies GmbH',
      description:
        "Type='MVCI_ISO_13400_DoIP_Vehicle' VIN='a7855437-a4a1-407' Master_MVCI='System'",
      hardwareName: 'MVCI_ISO_13400_DoIP_Vehicle',
      hardwareSerialNumber: '0',
      hardwareVersion: '1.0.0',
      firmwareName: 'none',
      firmwareVersion: '255.255.255',
      additionalAttributes: {
        vin: 'a7855437-a4a1-407',
        webSocketURL:
          'wss://remote-diag-integration-1.viessmann-platform.io/v1/connect?token=61bb5103-9135-4dc0-a9bf-067921282e69&role=technician',
      },
    },
    {
      name: 'ViessmannDoWS 2f586899-89dc-4ff7-bea6-157591cac5f0',
      resources: ['DOIP_MONITOR', 'ISO_13400_on_IEEE_802_3'],
      vciType: 'DOIP',
      vendorName: 'KPIT Technologies GmbH',
      description: "Type='MVCI_ISO_13400_DoIP_Vehicle' VIN='7722779976152001' Master_MVCI='System'",
      hardwareName: 'MVCI_ISO_13400_DoIP_Vehicle',
      hardwareSerialNumber: '0',
      hardwareVersion: '1.0.0',
      firmwareName: 'none',
      firmwareVersion: '255.255.255',
      additionalAttributes: {
        vin: '7722779976152001',
        webSocketURL:
          'wss://remote-diag-integration-1.viessmann-platform.io/v1/connect?token=2f586899-89dc-4ff7-bea6-157591cac5f0&role=technician',
      },
    },
  ];

  export const setupInfoMock: SetupInfo = {
    odx: '33.525.2245.2507',
    'D-PDU-API': '4.22.0',
    'Java Version': '11.0.15',
    'API Version': '81.505.2212.3',
    type: 'version information',
    'Runtime Simulation filepath': 'simulation.txt',
    Transformator: '3.20.0',
    'Runtime Manager': 'v4.25.000 b 1644488139177',
    'JVM arch': 'amd64',
    otx: '34.531.2250.0001',
    Runtime: '3.20.0',
    'JVM bit': '64',
    javajob: '1.2',
    'PDU API ini filepath': 'PDUAPI_KPIT.ini',
    'Project path': '/opt/mcd3d/viessmann/./ODXDataBin',
  };

  export const activeMock: DiagStackGenericResponse = {
    type: 'ReadActiveDTCVDDs',
    structure: [
      {
        severity: 'STATUS',
        RES:
          ' 62 01 01 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
        request_parameter_name: 'PA_DataIdent',
        service: 'DS_ReadDataByIdent',
        ecu: 'LL_0002_HMU_CAN01',
        requestDate: '2022-12-20T11:04:52.182+0000',
        ecuvariant: 'LL_0002_HMU_CAN01',
        request_parameter_value: 'StatusDtcList',
        securitystatus: '',
        type: 'ECU response structure by parameter name and value',
        REQ: ' 22 01 01',
      },
      {
        severity: 'INFO',
        RES:
          ' 62 01 03 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
        request_parameter_name: 'PA_DataIdent',
        service: 'DS_ReadDataByIdent',
        ecu: 'LL_0002_HMU_CAN01',
        requestDate: '2022-12-20T11:04:52.462+0000',
        ecuvariant: 'LL_0002_HMU_CAN01',
        request_parameter_value: 'InfoDtcList',
        securitystatus: '',
        type: 'ECU response structure by parameter name and value',
        REQ: ' 22 01 03',
      },
      {
        severity: 'SERVICE',
        RES:
          ' 62 01 05 02 00 08 00 14 16 0C 09 04 0B 09 33 01 00 01 00 14 16 0C 09 04 0B 09 03 01 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
        request_parameter_name: 'PA_DataIdent',
        service: 'DS_ReadDataByIdent',
        ecu: 'LL_0002_HMU_CAN01',
        requestDate: '2022-12-20T11:04:52.730+0000',
        ecuvariant: 'LL_0002_HMU_CAN01',
        request_parameter_value: 'ServiceDtcList',
        securitystatus: '',
        type: 'ECU response structure by parameter name and value',
        structure: [
          {
            semantic: '',
            path: 'PA_DataRecor',
            translationid: '',
            dopname: '2 Byte Table VDD Greenbook',
            name: 'PA_DataRecor',
            structure: [
              {
                semantic: 'FAULTREAD',
                path: 'PA_DataRecor/PA_DTC',
                translationid: 'TI_DTC',
                dopname: 'EOPF Structure DTC Service',
                name: 'PA_DTC',
                structure: [
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Service',
                    name: 'STR_12ByteStrucDTCServi',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcService',
                        dopname: '2 Byte TextTable DTCService',
                        name: 'PA_DTC',
                        value: 'BurnerOperatingHoursTillServiceExpired',
                        valuetranslationid: 'TI_P_8',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '51',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '1',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'OwnBus',
                        valuetranslationid: 'TI_OwnBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Service',
                    name: 'STR_12ByteStrucDTCServi',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcService',
                        dopname: '2 Byte TextTable DTCService',
                        name: 'PA_DTC',
                        value: 'HoursTillServiceExpired',
                        valuetranslationid: 'TI_P_1',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '3',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '1',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCServi/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'OwnBus',
                        valuetranslationid: 'TI_OwnBus',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
        REQ: ' 22 01 05',
      },
      {
        severity: 'WARNING',
        RES:
          ' 62 01 07 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
        request_parameter_name: 'PA_DataIdent',
        service: 'DS_ReadDataByIdent',
        ecu: 'LL_0002_HMU_CAN01',
        requestDate: '2022-12-20T11:04:53.017+0000',
        ecuvariant: 'LL_0002_HMU_CAN01',
        request_parameter_value: 'WarningDtcList',
        securitystatus: '',
        type: 'ECU response structure by parameter name and value',
        REQ: ' 22 01 07',
      },
      {
        severity: 'ERROR',
        RES:
          ' 62 01 09 08 00 41 02 14 16 0C 09 04 0B 09 21 01 00 3E 02 14 16 0C 09 04 0B 09 21 01 00 44 02 14 16 0C 09 04 0B 09 21 01 00 5C 00 14 16 0C 09 04 0B 09 1E 01 01 05 02 14 16 0C 09 04 0B 09 1E 30 01 5C 00 14 16 0C 09 04 0B 09 1E 02 01 5C 00 14 16 0C 09 04 0B 09 1E 03 01 5C 00 14 16 0C 09 04 0B 09 1C 00 01 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
        request_parameter_name: 'PA_DataIdent',
        service: 'DS_ReadDataByIdent',
        ecu: 'LL_0002_HMU_CAN01',
        requestDate: '2022-12-20T11:04:53.300+0000',
        ecuvariant: 'LL_0002_HMU_CAN01',
        request_parameter_value: 'ErrorDtcList',
        securitystatus: '',
        type: 'ECU response structure by parameter name and value',
        structure: [
          {
            semantic: '',
            path: 'PA_DataRecor',
            translationid: '',
            dopname: '2 Byte Table VDD Greenbook',
            name: 'PA_DataRecor',
            structure: [
              {
                semantic: 'FAULTREAD',
                path: 'PA_DataRecor/PA_DTC',
                translationid: 'TI_DTC',
                dopname: 'EOPF Structure DTC Error',
                name: 'PA_DTC',
                structure: [
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'MixerTwoRoomTemperatureSensorNotAvailable',
                        valuetranslationid: 'TI_F_577',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '33',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '1',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'OwnBus',
                        valuetranslationid: 'TI_OwnBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'MixerOneRoomTemperatureSensorNotAvailable',
                        valuetranslationid: 'TI_F_574',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '33',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '1',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'OwnBus',
                        valuetranslationid: 'TI_OwnBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'MixerThreeRoomTemperatureSensorNotAvailable',
                        valuetranslationid: 'TI_F_580',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '33',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '1',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'OwnBus',
                        valuetranslationid: 'TI_OwnBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'FailureCommunicationAdioModule',
                        valuetranslationid: 'TI_F_92',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '30',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '1',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'PlusBus',
                        valuetranslationid: 'TI_PlusBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'FailureCommunicationWiredRemoteControl',
                        valuetranslationid: 'TI_F_517',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '30',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '48',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'PlusBus',
                        valuetranslationid: 'TI_PlusBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'FailureCommunicationAdioModule',
                        valuetranslationid: 'TI_F_92',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '30',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '2',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'PlusBus',
                        valuetranslationid: 'TI_PlusBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'FailureCommunicationAdioModule',
                        valuetranslationid: 'TI_F_92',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '30',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '3',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'PlusBus',
                        valuetranslationid: 'TI_PlusBus',
                      },
                    ],
                  },
                  {
                    semantic: '',
                    path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError',
                    translationid: '',
                    dopname: '12 Byte Structure DTC Error',
                    name: 'STR_12ByteStrucDTCError',
                    structure: [
                      {
                        semantic: 'FAULTREAD',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DTC',
                        unit: '',
                        translationid: 'TI_DtcError',
                        dopname: '2 Byte TextTable DTCError',
                        name: 'PA_DTC',
                        value: 'FailureCommunicationAdioModule',
                        valuetranslationid: 'TI_F_92',
                      },
                      {
                        semantic: 'DATETIME',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime',
                        translationid: 'TI_Time',
                        dopname: '8 Byte Structure DateTime',
                        name: 'PA_DtcTime',
                        structure: [
                          {
                            semantic: 'DATE',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date',
                            translationid: 'TI_Date',
                            dopname: '4 Byte Structure Date',
                            name: 'PA_Date',
                            structure: [
                              {
                                semantic: 'CENTURY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Centu',
                                unit: '',
                                translationid: 'TI_Century',
                                dopname: '1 Byte Identical uint8 Century',
                                name: 'PA_Centu',
                                value: '20',
                              },
                              {
                                semantic: 'YEAR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Year',
                                unit: 'yr',
                                translationid: 'TI_Year',
                                dopname: '1 Byte Identical uint8 Year',
                                name: 'PA_Year',
                                value: '22',
                              },
                              {
                                semantic: 'MONTH',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Month',
                                unit: 'm',
                                translationid: 'TI_Month',
                                dopname: '1 Byte Identical uint8 Month',
                                name: 'PA_Month',
                                value: '12',
                              },
                              {
                                semantic: 'DAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Date/PA_Day',
                                unit: 'd',
                                translationid: 'TI_Day',
                                dopname: '1 Byte Identical uint8 Day',
                                name: 'PA_Day',
                                value: '9',
                              },
                            ],
                          },
                          {
                            semantic: 'TIME',
                            path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time',
                            translationid: 'TI_Time',
                            dopname: '4 Byte Structure Time',
                            name: 'PA_Time',
                            structure: [
                              {
                                semantic: 'WEEKDAY',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Weekd',
                                unit: '',
                                translationid: 'TI_Weekday',
                                dopname: '1 Byte TextTable WeekDay',
                                name: 'PA_Weekd',
                                value: 'Friday',
                                valuetranslationid: 'TI_Friday',
                              },
                              {
                                semantic: 'HOUR',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Hour',
                                unit: 'h',
                                translationid: 'TI_Hour',
                                dopname: '1 Byte Identical uint8 Hour',
                                name: 'PA_Hour',
                                value: '11',
                              },
                              {
                                semantic: 'MINUTE',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Minut',
                                unit: 'min',
                                translationid: 'TI_Minute',
                                dopname: '1 Byte Identical uint8 Minute',
                                name: 'PA_Minut',
                                value: '9',
                              },
                              {
                                semantic: 'SECOND',
                                path:
                                  'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_DtcTime/PA_Time/PA_Secon',
                                unit: 's',
                                translationid: 'TI_Second',
                                dopname: '1 Byte Identical uint8 Second',
                                name: 'PA_Secon',
                                value: '28',
                              },
                            ],
                          },
                        ],
                      },
                      {
                        semantic: 'VALUE',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusAddre',
                        unit: '',
                        translationid: 'TI_BusAddress',
                        dopname: '1 Byte Identical uint8 Hex',
                        name: 'PA_BusAddre',
                        value: '0',
                      },
                      {
                        semantic: 'ENUM',
                        path: 'PA_DataRecor/PA_DTC/STR_12ByteStrucDTCError/PA_BusType',
                        unit: '',
                        translationid: 'TI_BusType',
                        dopname: '1 Byte TextTable BusType',
                        name: 'PA_BusType',
                        value: 'PlusBus',
                        valuetranslationid: 'TI_PlusBus',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
        REQ: ' 22 01 09',
      },
    ],
  };
}
